import React from "react";
import {
    Pagination,
    PaginationItem,
    PaginationLink,
    Row,
    Col,
    NavLink
} from "reactstrap";
import { makeStyles } from '@material-ui/core/styles';
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Popover from "@material-ui/core/Popover";
import NoteAddIcon from '@material-ui/icons/NoteAdd';
import DeleteIcon from '@material-ui/icons/Delete';
import SettingsIcon from '@material-ui/icons/Settings';
import LastPageIcon from '@material-ui/icons/LastPage';
import FirstPageIcon from '@material-ui/icons/FirstPage';
import { IconButton, Tooltip } from "@material-ui/core";
import SystemLabel from "../../../../../system/SystemLabel/SystemLabel";

const useStyles = makeStyles((theme) => ({
    paper: {
        background: 'transparent',
    },
}));

export const PopList = ({ icon, children, tooltipText }) => {
    const classes = useStyles();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClose = () => {
        setAnchorEl(null);
    };
    const handleClick = event => {
        setAnchorEl(event.currentTarget);
    };


    const open = Boolean(anchorEl);
    const id = open ? "simple-popover" : undefined;
    return (
        <React.Fragment>
            <Tooltip title={<SystemLabel name={tooltipText} />}>


                <IconButton
                    onClick={handleClick}
                    edge="start"
                    color="inherit"
                    aria-label="activeparticipants"
                    style={{ margin: "0px", position: 'relative', color: '#fff' }}
                >
                    {icon}
                </IconButton>
            </Tooltip>
            <Popover
                id={id}
                open={open}
                classes={{
                    paper: classes.paper,
                }}
                anchorEl={anchorEl}
                onClose={handleClose}
                style={{ zIndex: 10000, padding: "10px" }}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "center"
                }}
            >
                {children}
            </Popover>
        </React.Fragment>


    );
};

